import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Award, TrendingUp, TrendingDown, AlertTriangle } from "lucide-react";

export function QualityControlDashboard() {
  // Mock data - would come from review_quality_audits table
  const metrics = {
    overallAccuracy: 94.5,
    aiAgreement: 88.2,
    avgReviewTime: 11.5,
    qualityTrend: "up",
    recentAudits: [
      { reviewer: "Sarah Johnson", accuracy: 96, reviews: 45, flags: 2 },
      { reviewer: "Mike Chen", accuracy: 94, reviews: 38, flags: 3 },
      { reviewer: "Emma Davis", accuracy: 98, reviews: 52, flags: 1 },
      { reviewer: "James Wilson", accuracy: 92, reviews: 31, flags: 4 },
    ],
  };

  return (
    <div className="space-y-6">
      <div className="grid gap-4 md:grid-cols-4">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Overall Accuracy</CardTitle>
            <Award className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{metrics.overallAccuracy}%</div>
            <div className="flex items-center gap-1 text-xs text-green-500">
              <TrendingUp className="h-3 w-3" />
              +2.3% vs last week
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">AI Agreement</CardTitle>
            <TrendingUp className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{metrics.aiAgreement}%</div>
            <p className="text-xs text-muted-foreground">
              Alignment with AI extraction
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Avg Review Time</CardTitle>
            <TrendingDown className="h-4 w-4 text-green-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{metrics.avgReviewTime}m</div>
            <p className="text-xs text-muted-foreground">
              Per bill review
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Quality Issues</CardTitle>
            <AlertTriangle className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">10</div>
            <p className="text-xs text-muted-foreground">
              Flagged this week
            </p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Reviewer Performance</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {metrics.recentAudits.map((audit, idx) => (
            <div key={idx} className="space-y-2">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium">{audit.reviewer}</p>
                  <p className="text-xs text-muted-foreground">
                    {audit.reviews} reviews • {audit.flags} quality flags
                  </p>
                </div>
                <Badge variant={audit.accuracy >= 95 ? "outline" : "secondary"} className={audit.accuracy >= 95 ? "border-green-500 text-green-500" : ""}>
                  {audit.accuracy}% accuracy
                </Badge>
              </div>
              <Progress value={audit.accuracy} className="h-2" />
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
